import React from 'react';
import { Card, CardHeader, CardMedia, CardContent, Typography, Button, Grid, Box } from '@mui/material';
import TruncatedTextWithTooltip from '../elements/TruncatedTextWithTooltip.tsx';
import { formatDate, getEventStatus } from '../../utils/index.tsx';
import { EventsCardProps } from '../../types.ts';

const EventsCard: React.FC<EventsCardProps> = ({ event, onRegisterClick, selectedChildId }) => {
    const { status, className } = getEventStatus(event, selectedChildId);

    const handleRegisterClick = () => {
        onRegisterClick(event);
    };

    return (
        <Card sx={{ height: '100%', boxShadow: 8, minWidth: '320px' }} className="events-card" elevation={3}>
            <CardMedia
                component="div"
                sx={{
                    height: '180px',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${event.signedUrl || ''})`,
                    backgroundSize: 'unset'
                }}
            />

            <CardHeader
                title={event.name}
                subheader={`${formatDate(event.startDate)} - ${formatDate(event.endDate)}`}
            />
            <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, paddingBottom: '19px !important' }}>
                <TruncatedTextWithTooltip text={event.description} maxLength={145} />
                <Box sx={{ mt: 'auto' }}>
                    <Grid container spacing={{ xs: 1, xl: 2 }}  alignItems="center" justifyContent="space-between" mt={{ xs: 1}}>
                        <Grid item xs={8.25} xl={8}>
                            {status === 'Open' && event.totalOccupiedSeats !== event.capacity && (
                                <Button
                                    variant="contained"
                                    fullWidth
                                    className={className}
                                    onClick={handleRegisterClick}
                                >
                                    Registration Open
                                </Button>
                            )}
                            {(status !== 'Open' || event.totalOccupiedSeats >= event.capacity) && !event.isWaitlistEnabled && (
                                <Button
                                    variant="contained"
                                    fullWidth
                                    className={className}
                                    disabled
                                >
                                    Registration Closed
                                </Button>
                            )}
                            {event.totalOccupiedSeats >= event.capacity && !!event.isWaitlistEnabled && (
                                <Button
                                    variant="contained"
                                    fullWidth
                                    className={"open"}
                                    onClick={handleRegisterClick}
                                >
                                    Waitlist Open
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={3.75} xl={4}>
                            <Typography variant="body2" color="text.secondary" className="spots-left">
                                {event.totalOccupiedSeats === event.capacity ? 'No Spots Left' :
                                    event.capacity - event.totalOccupiedSeats === 1 ? '1 Spot Left' :
                                        `${event.capacity - event.totalOccupiedSeats} Spots Left`}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    );
};

export default EventsCard;
